import { render, staticRenderFns } from "./DismissalBigScreenOld.vue?vue&type=template&id=97665ab6&scoped=true"
import script from "./DismissalBigScreenOld.vue?vue&type=script&lang=js"
export * from "./DismissalBigScreenOld.vue?vue&type=script&lang=js"
import style0 from "./DismissalBigScreenOld.vue?vue&type=style&index=0&id=97665ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97665ab6",
  null
  
)

export default component.exports